export default "__VITE_ASSET__1d673321__"